import _ from 'lodash';
import * as lc from '../../../../../utils/lodashCustom';

export function restructureMenuItemModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    seoUrl: lc.get(data, 'seo_url')
  };
}

export function restructureContentModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    isPopular: lc.get(data, 'is_popular'),
    parent:
      _.get(data, 'parent') !== null
        ? restructureMenuItemModel(state, _.get(data, 'parent'))
        : null,
    title: lc.get(data, 'title'),
    sort: lc.get(data, 'sort'),
    seoUrl: lc.get(data, 'seo_url'),
    beforeContentSeoUrl:
      _.get(data, 'beforeContentSeoUrl') !== null
        ? restructureMenuItemModel(state, _.get(data, 'beforeContentSeoUrl'))
        : null,
    nextContentSeoUrl:
      _.get(data, 'nextContentSeoUrl') !== null
        ? restructureMenuItemModel(state, _.get(data, 'nextContentSeoUrl'))
        : null,
    html: lc.get(data, 'html'),
    shortDesc: lc.get(data, 'short_desc'),
    createdAt: lc.get(data, 'created_at'),
    children: _.map(data.children, item =>
      restructureMenuItemModel(state, item)
    )
  };
}

export function restructurePopularItemModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    isPopular: lc.get(data, 'is_popular'),
    popularSort: lc.get(data, 'popular_sort'),
    parent:
      lc.get(data, 'parent') !== null
        ? restructureMenuItemModel(state, lc.get(data, 'parent'))
        : null,
    title: lc.get(data, 'title'),
    seoUrl: lc.get(data, 'seo_url'),
    shortDesc: lc.get(data, 'short_desc')
  };
}

export function restructureSearchItemModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    parent:
      _.get(data, 'parent', null) !== null
        ? restructureSearchItemModel(state, lc.get(data, 'parent'))
        : null,
    title: lc.get(data, 'title'),
    seoUrl: lc.get(data, 'seo_url'),
    searchTitle: lc.get(data, 'search_title'),
    searchContent: lc.get(data, 'search_content'),
    relevant: lc.get(data, 'relevant'),
    html: lc.get(data, 'html')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/faqContents/services/FaqContentsService/restructuring/index.js